import axios from '@/config/httpConfig'
// 获取视图排序
export function GetSortView(data) {
    return axios.post('/view/getSortView', data)
}
// 保存视图排序
export function SaveSortView(data) {
    return axios.post('/view/saveSortView', data)
}
